import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.member,
        "error-message": _ctx.errorMessage
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
    }, 16, ["name", "error-message"]));
}
